import React from 'react';
import YTVideoItemHolder from './YTVideoItemStyles';

const YTVideoItem = ({video, onVideoSelect})=> {
	return (
		<YTVideoItemHolder>
			<div onClick={()=> onVideoSelect(video)} onKeyPress={()=> onVideoSelect(video)} className="yt-video-item" tabIndex="0" itemProp="itemListElement">
				{ video.snippet.thumbnails.medium &&
					<img src={video.snippet.thumbnails.medium.url} alt={video.snippet.title} itemProp='image'/> }
				<div className="yt-video-description" itemProp='description'>
					{video.snippet.title}
				</div>
			</div>
		</YTVideoItemHolder>
	)
}

export default YTVideoItem;